var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10C16 13.3137 13.3137 16 10 16ZM10 9C10.413 9 10.7719 8.84817 11.0762 8.54394C11.3588 8.26134 11.5 7.91304 11.5 7.5C11.5 7.08696 11.3588 6.72818 11.0762 6.42383C10.7718 6.14122 10.413 6 10 6C9.58696 6 9.23866 6.14122 8.95606 6.42383C8.65184 6.72813 8.5 7.08704 8.5 7.5C8.5 7.91303 8.65172 8.26134 8.95606 8.54394C9.23866 8.84828 9.58697 9 10 9ZM11.1035 14C11.314 14 11.4773 13.8153 11.4512 13.6064L11.0381 10.3066C11.0162 10.1316 10.8678 10.0002 10.6914 10L9.30859 10C9.13225 10.0002 8.98379 10.1316 8.96191 10.3066L8.54883 13.6064C8.52272 13.8153 8.68596 14 8.89648 14L11.1035 14Z",
    fill: "#347CAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationB);
export default __webpack_public_path__ + "static/media/exclamation-b.0b9c63fa348eaaa203fffd048021d97a.svg";
export { ForwardRef as ReactComponent };